import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';
import Logo from '../components/Logo';

const API = getApiBaseUrl();

export default function ForgotPasswordPage() {
    const { t } = useTranslation(['auth', 'common']);
    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        try {
            await axios.post(`${API}/auth/forgot-password`, { email: email.trim() });
        } catch {
            /* always show success */
        }
        setSent(true);
        setLoading(false);
    }

    return (
        <div className="sp-auth-page page-login">
            <div className="sp-auth-form-panel" style={{ width: '100%', justifyContent: 'center' }}>
                <div style={{ width: '100%', maxWidth: 420, margin: '0 auto' }}>
                    <div style={{ textAlign: 'center', marginBottom: 24 }}>
                        <Logo variant="light" height={40} style={{ margin: '0 auto 24px' }} />
                    </div>
                    <div className="sp-data-card" style={{ padding: 36 }}>
                        {!sent ? (
                            <>
                                <h1 style={{ margin: '0 0 8px', fontSize: 22, textAlign: 'center' }}>{t('forgotMobile.title')}</h1>
                                <p style={{ color: '#64748b', fontSize: 14, textAlign: 'center', marginBottom: 24 }}>
                                    {t('forgotMobile.subtitle')}
                                </p>
                                <form onSubmit={handleSubmit}>
                                    <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 6 }}>{t('common:email')}</label>
                                    <input
                                        className="sp-input"
                                        type="email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        required
                                        autoComplete="email"
                                        style={{ marginBottom: 20 }}
                                    />
                                    <button
                                        type="submit"
                                        disabled={loading || !email.trim()}
                                        className="sp-btn sp-btn--primary"
                                        style={{ width: '100%' }}
                                    >
                                        {loading ? t('forgotMobile.sending') : t('forgotMobile.submit')}
                                    </button>
                                </form>
                            </>
                        ) : (
                            <div style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: 48, marginBottom: 16 }}>✉️</div>
                                <p style={{ fontSize: 15, lineHeight: 1.6, marginBottom: 20 }}>
                                    {t('forgotMobile.subtitle')}
                                    {' '}
                                    {t('forgotMobile.spamHint')}
                                </p>
                                <Link to="/login" className="sp-btn sp-btn--secondary" style={{ display: 'inline-block', textDecoration: 'none' }}>
                                    {t('forgotMobile.backToLogin')}
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
